import { IsEmail, IsEnum, IsNotEmpty, IsString, IsUrl, Length, ValidateIf } from 'class-validator';
import { PARTNERS_TYPE } from '../components/pages/partners/new/form/constants';
import type { PartnersType } from '../components/pages/partners/new/form/types';

import { ERROR_MESSAGE, HAS_KOR } from './constants';
import { IsPhoneNumber, NotMatches, Trim } from './decorator';

class MarketingPartnersValidator {
  static readonly NAME_MIN_LENGTH = 1;
  static readonly NAME_MAX_LENGTH = 50;

  @IsEnum(PARTNERS_TYPE)
  type: PartnersType;

  @Trim()
  @IsString()
  @Length(MarketingPartnersValidator.NAME_MIN_LENGTH, MarketingPartnersValidator.NAME_MAX_LENGTH, {
    message: ERROR_MESSAGE.LENGTH(
      MarketingPartnersValidator.NAME_MIN_LENGTH,
      MarketingPartnersValidator.NAME_MAX_LENGTH,
    ),
  })
  name: string;

  @Trim()
  @IsEmail({}, { message: ERROR_MESSAGE.INVALID_EMAIL })
  @NotMatches(RegExp(HAS_KOR), {
    message: ERROR_MESSAGE.INVALID_EMAIL,
  })
  email: string;

  @Trim()
  @IsPhoneNumber({
    message: ERROR_MESSAGE.IS_NOT_KOREAN_NUMBER,
  })
  @IsNotEmpty({
    message: ERROR_MESSAGE.IS_NOT_EMPTY,
  })
  phone: string;

  @Trim()
  countryCode: string;

  @Trim()
  @ValidateIf((partners) => partners.type === PARTNERS_TYPE.BUSINESS)
  @IsUrl(
    { protocols: ['http', 'https'], require_protocol: true },
    { message: ERROR_MESSAGE.INVALID_URL() },
  )
  activityLink?: string;
}

export default MarketingPartnersValidator;
